import imageLoader from 'components/listing-image/image-loader';
import { useRef } from 'react';
import { InView } from 'react-intersection-observer';

type VideoProps = {
  src: string;
  poster?: string;
  posterQuality?: number;
  /** The MIME type of the video (e.g., 'video/mp4', 'video/webm') */
  type: string;
  muted?: boolean;
  loop?: boolean;
  playsInline?: boolean;
  /** 
   * The playback mode for the video
   * - 'autoPlayWhenVisible': Video automatically plays when it comes into view and pauses when out of view
   * - 'staticFrame': Video remains static (no autoplay behavior)
   * @default 'autoPlayWhenVisible'
   */
  mode?: 'autoPlayWhenVisible' | 'staticFrame';
  className?: string;
  style?: React.CSSProperties;
};

const Video = ({ src, type, mode = 'autoPlayWhenVisible', posterQuality = 50, playsInline = false, ...rest }: VideoProps) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  const handleInViewChange = inView => {
    switch (mode) {
      case 'staticFrame':
        break;
      case 'autoPlayWhenVisible':
        if (rest.muted) console.warn('Video is not muted, so it will not autoplay when visible');
        if (inView) {
          videoRef.current?.play();
        }
        break;
      default:
        console.warn('Invalid mode, so it will not autoplay when visible');
        break;
    }
  };

  return (
    <InView onChange={handleInViewChange}>
      <video
        muted
        {...rest}
        ref={videoRef}
        playsInline={playsInline}
        poster={rest.poster ? imageLoader({ src: rest.poster, quality: posterQuality }) : undefined}
      >
        <source src={src} type={type} />
      </video>
    </InView>
  );
};

export default Video;